module.exports = __webpack_public_path__ + "static/FooterLogo-18347253ee4624d6a843daf89b81fc65.svg";